/* Count the number of events that occur in an event schedule */
export default function (schedule, startDate) {
  const {recurrenceEndDate, recurrenceCount, daysOfWeek, weeksBetween} = schedule;
  if (recurrenceCount) {
    return recurrenceCount;
  } else if (recurrenceEndDate) {
    const followingDay = recurrenceEndDate
      .clone()
      .startOf('day')
      // recurrenceEndDate is inclusive, add a day:
      .add(1, 'day');
    const time = startDate.clone().set(schedule.time.toJS());
    if (time.isBefore(startDate)) {
      time.add(1, 'day');
    }
    let meetingCount = 0;
    while (time.isBefore(followingDay)) {
      if (daysOfWeek.includes(time.format('dddd'))) {
        meetingCount++;
      }
      time.add(1, 'day');
      if (weeksBetween && time.day() === 0) {
        time.add(weeksBetween - 1, 'week');
      }
    }
    return meetingCount;
  }
  return Infinity;
}
